export interface ChatState {
  messages: Message[];
  pendingMessages: { service_id: number; count: number }[];
  currentMessage: Message | null;
  mediaUploadDetails: MediaUploadDetails | null;
  mediaFile: File,
  mediaMessage: MediaMessage | null;
  isLoading: boolean;
  error: string | null;
  failedMessages: Message[]; 
}

// El estado inicial se establece con valores nulos
export const initialState: ChatState = {
  messages: [],
  pendingMessages: [],
  currentMessage: null,
  mediaUploadDetails: null,
  mediaFile: null,
  mediaMessage: null,
  isLoading: false,
  error: null,
  failedMessages: [], 
};


  export type Message =  TextMessage | MediaMessage;
    

  
  export interface BaseMessage {
    client_timestamp: number;
    id?: number;
    message_type: string;
    sender?: Sender;
    sender_type: number;
    service_id?: number;
    messageSent?: boolean;
    isSending?: boolean;
  }
  
  export interface TextMessage extends BaseMessage {
    content: {
      text: string;
    };
  }
  
  export interface MediaMessage extends BaseMessage {
    media_caption: string;
    content: {
      media: {
        mimetype: string;
        filename: string | Blob;
        object_key: string;
      };
      image: string;
    };
  }


  export interface MediaUploadDetails {
    content_type: string;
    object_key: string;
    pre_signed_put_url: string;
  }
  
  interface Sender {
    active?: boolean;
    email?: string;
    id?: number | null;
    name?: string;
    phone?: string;
    rider_profile?: any | null;
    role?: number;
    user_type?: string;
  }

 
 